import React from 'react';
import { FacilityEditTemplate } from 'themes/application/facility/pages';
import { observer } from 'mobx-react';
import { FacilityEditViewStore } from 'application/facility/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new FacilityEditViewStore(rootStore), 'editView')
@observer
class FacilityEdit extends React.Component {
    render() {
        return <FacilityEditTemplate {...this.props} />
    }
}

export default FacilityEdit;